import LogsList from "../../components/Logs/LogsList";
function AdminLogs(){

  return (
  <div>

    <LogsList   />
  </div>
  );
}
export default AdminLogs;